var React = require('react');

function LogoLines (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#231F20","d":"M0 56.559v14.118h84.794V240h14.124V70.678h14.141V240h14.14V70.678h14.124V240h14.124V70.678h84.794v-14.12H0ZM240.241 28.338H0V42.44h240.241V28.338ZM240.241.118H0v14.119h240.241V.118Z"}));
}

LogoLines.defaultProps = {"viewBox":"0 0 241 240","fill":"none"};

module.exports = LogoLines;

LogoLines.default = LogoLines;
